<template>
  <div class="container-fluid">
    <Card>
      <template slot="header">
        <h4>مشتریان مشابه</h4>
        <hr />
      </template>
      <template slot="content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-4 mt-2 col-12">
              <small id="LblHadaf"> گروه هــدف</small>
              <SearchableCombo :edit="false" :grp="3" :code="null" @ResultCombo="GetResultGHadaf" :rownumintable="3" :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'GHadaf'" :defaultvalue="DataAxiosSearch.ArryfildValue.tblCombogrp3GHadaf" :keyItem="'GHadaf'" :disabled="false">
              </SearchableCombo>
            </div>
            <div class="col-lg-4 mt-2 col-12">
              <small id="LblHadaf"> هــدف </small>
              <SearchableCombo :edit="false" :grp="4" :code="null" @ResultCombo="GetResultHadaf" :defaultvalue="DataAxiosSearch.ArryfildValue.tblCombogrp4Hadaf" :rownumintable="3" :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'Hadaf'" :keyItem="'Hadaf'" :disabled="false">
              </SearchableCombo>
            </div>
            <div class="col-lg-4 mt-2 col-12">
              <small id="LblHadaf">استـــان</small>
              <SearchableCombo :edit="false" :grp="10" :code="null" @ResultCombo="GetResultOstan" :defaultvalue="DataAxiosSearch.ArryfildValue.tblCombogrp10Ostan" :rownumintable="10" :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'Ostan'" :keyItem="'Ostan'" :disabled="false">
              </SearchableCombo>
            </div>
            <div class="col-lg-4 mt-2 col-12">
              <small id="LblHadaf">شهـــر</small>
              <SearchableCombo
                v-if="$store.state.renderComponentCombo"
                :edit="false"
                :grp="11"
                :code="DataAxiosSearch.ArryfildValue.tblCombogrp10Ostan"
                @ResultCombo="GetResultCity"
                :defaultvalue="DataAxiosSearch.ArryfildValue.tblCombogrp11City"
                :rownumintable="10"
                :action="'TblCrmCombo/GetComboByParentId'"
                :method="'POST'"
                :idinput="'City'"
                :keyItem="'City'"
                :disabled="DataAxiosSearch.ArryfildValue.tblCombogrp10Ostan == null"
              >
              </SearchableCombo>
            </div>
            <div class="col-lg-4 mt-2 col-12">
              <small id="LblHadaf"> سیستم قبــلی</small>
              <SearchableCombo :edit="false" :grp="13" :code="null" @ResultCombo="GetResultOldSys" :rownumintable="13" :action="'TblCrmCombo/GetComboById'" :defaultvalue="DataAxiosSearch.ArryfildValue.tblCombogrp13OldSys" :method="'POST'" :idinput="'OldSys'" :keyItem="'OldSys'" :disabled="false">
              </SearchableCombo>
            </div>
            <div class="col-lg-4 mt-2 col-12">
              <button @click="Search()" class="btn btn-success w-100 mt-4">جستجو</button>
            </div>
            <div class="col-12">
              <BnpGrid Selectable :Sortable="true" :action="true" :propsRows="propsRows" :propsColumn="propsColumn" :NoRowNum="true" v-if="$store.state.renderComponentGrid">
                <template slot="action-slot" slot-scope="props">
                  <a href="javascript:;" class="mr-2 badge" @click="OnDetail(props.props)"
                    ><h6><span class="fas fa-eye font-weight-bold hover-danger"></span></h6
                  ></a>
                </template>
                <template slot="customerName" slot-scope="props">
                  <span> {{ props.props.customerName }}</span> <span v-if="props.props.baygani">(بایگانی شده)</span>
                </template>
              </BnpGrid>
            </div>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
export default {
  data() {
    return {
      DataAxiosSearch: {
        Method: 'POST',
        Action: 'Reports/SimilarCustomers',
        ArryfildValue: {
          tblCombogrp13OldSys: null,
          tblCombogrp10Ostan: null,
          tblCombogrp11City: null,
          tblCombogrp4Hadaf: null,
          tblCombogrp3GHadaf: null,
        },
      },
      propsColumn: [
        { name: 'customerCode', label: 'کد', visibility: true },
        { name: 'customerName', label: 'نام مشتری', visibility: true },
        { name: 'codeBazaryabi', label: ' کد بازاریابی', visibility: true },
        { name: 'tblCombogrp37AxarinVazeitName', label: 'وضعیت فعالیت', visibility: true },
      ],
      propsRows: [],
    }
  },
  components: { Card, SearchableCombo, BnpGrid },
  methods: {
    GetResultOldSys(data) {
      this.DataAxiosSearch.ArryfildValue.tblCombogrp13OldSys = data.id
    },
    GetResultCity(data) {
      this.DataAxiosSearch.ArryfildValue.tblCombogrp11City = data.id
    },
    GetResultOstan(data) {
      this.DataAxiosSearch.ArryfildValue.tblCombogrp10Ostan = data.id
      this.$store.state.renderComponentCombo = false
      this.$nextTick(() => {
        this.$store.state.renderComponentCombo = true
      })
    },
    GetResultHadaf(data) {
      this.DataAxiosSearch.ArryfildValue.tblCombogrp4Hadaf = data.id
    },
    GetResultGHadaf(data) {
      this.DataAxiosSearch.ArryfildValue.tblCombogrp3GHadaf = data.id
    },
    Search() {
      this.$PostData(this.DataAxiosSearch).then((result) => {
        this.propsRows = result
        this.$mySweetDefaultTost('جستـــجو موفـق', '', 'success', 1000)

        this.$store.state.renderComponentGrid = false
        this.$nextTick(() => {
          this.$store.state.renderComponentGrid = true
        })
        this.$store.state.tblCombogrp3GHadaf = this.DataAxiosSearch.ArryfildValue.tblCombogrp3GHadaf
        this.$store.state.tblCombogrp4Hadaf = this.DataAxiosSearch.ArryfildValue.tblCombogrp4Hadaf
        this.$store.state.tblCombogrp11City = this.DataAxiosSearch.ArryfildValue.tblCombogrp11City
        this.$store.state.tblCombogrp10Ostan = this.DataAxiosSearch.ArryfildValue.tblCombogrp10Ostan
        this.$store.state.tblCombogrp13OldSys = this.DataAxiosSearch.ArryfildValue.tblCombogrp13OldSys
        this.$store.state.SimilarCustomers = result
      })
    },
    OnDetail(data) {
      // console.log(data)
      // this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: data.id } })
      this.$FindeCustomerById('DetailCustomer',data.id ,false,null)
    },
  },
  created() {
    if (this.$store.state.SimilarCustomers && this.$store.state.SimilarCustomers.length > 0) {
      this.propsRows = this.$store.state.SimilarCustomers
      this.DataAxiosSearch.ArryfildValue.tblCombogrp3GHadaf = this.$store.state.tblCombogrp3GHadaf
      this.DataAxiosSearch.ArryfildValue.tblCombogrp4Hadaf = this.$store.state.tblCombogrp4Hadaf
      this.DataAxiosSearch.ArryfildValue.tblCombogrp11City = this.$store.state.tblCombogrp11City
      this.DataAxiosSearch.ArryfildValue.tblCombogrp10Ostan = this.$store.state.tblCombogrp10Ostan
      this.DataAxiosSearch.ArryfildValue.tblCombogrp13OldSys = this.$store.state.tblCombogrp13OldSys
    }
  },
}
</script>
